module.exports = __webpack_public_path__ + "static/media/theme_icon_two.7360ef82.png";